/**
* User management & login
*/
module.config(['$stateProvider', 'urls', function ($stateProvider, urls) {
    'use strict';
    $stateProvider
        .state('member.assessments', {
            url: '/' + urls.member.assessments.fr + '/',
            abstract: true,
            views: {
                aside: {
                    templateUrl: 'src/views/member/member_aside.html'
                },
                content: {
                    controller: ['$scope', '$rootScope', '$filter', function ($scope, $rootScope, $filter) {
                        // remove warning message
                        if ($scope.teaserPanel.css === 'info') {
                            angular.merge($scope.teaserPanel, { css: null, body: null });
                        }

                        if ($scope.breadcrumb.length > 2) {
                            $scope.breadcrumb.pop();
                        }
                        $scope.breadcrumb.push({ label: $filter('translate')('account.satisfaction'), state: 'member.assessments' });
                        $rootScope.title = $filter('translate')('account.title') + ' - ' + $filter('translate')('account.satisfaction');
                        $rootScope.titlePanel = $filter('translate')('account.satisfaction');
                    }],
                    template: '  <div ui-view="subcontent"></div>'
                },
            },
        })
        .state('member.assessments.list', {
            url: '',
            params: {
                message: null
            },
            views: {
                subcontent: {
                    controller: ['$scope', '$rootScope', '$filter', '$state', 'drupal', 'moment', 'tools', 'utils', function ($scope, $rootScope, $filter, $state, $drupal, moment, tools, utils) {
                        $scope.pending = true;
                        $scope.tools = tools;
                        // filters model
                        $scope.filtersReady = false;

                        $scope.basenameDefault = 'Toutes';
                        $scope.audienceDefault = 'Tous';
                        $scope.dateRegex = new RegExp("^(?:(?:31(\\/)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$");

                        $scope.filters = {
                            basename: [
                                { name: $filter('translate')('form.allF') }
                            ],
                            audience: [
                                { name: $filter('translate')('form.all') }
                            ],
                            input: {
                                date: '13/01/2018',
                                audience: $scope.audienceDefault,
                                basename: $scope.basenameDefault
                            }
                        };
                        $scope.$watch('filters.input', function (input) {
                            $scope.doFilter();
                        }, true);

                        // retrieve basename list and audience values
                        $drupal.getCriteria().then(function (criterias) {
                            if (criterias.filters && criterias.filters.basename && criterias.filters.basename.options && criterias.filters.audience.options) {
                                // retrieve all basename
                                criterias.filters.basename.options.forEach(function (region) {
                                    region.options.forEach(function (base) {
                                        $scope.filters.basename.push(base);
                                    });
                                });
                                // retrieve all audience type
                                criterias.filters.audience.options.forEach(function (type) {
                                    $scope.filters.audience.push(type);
                                })
                            }
                            $scope.filtersReady = true;
                        });

                        // retrieve internships list
                        $scope.internshipsData = {
                            filtered: [],
                            full: [],
                            start: 0,
                            page: 0
                        };

                        // default pagination
                        $scope.defaultNumberToShow = 10;

                        $scope.doFilter = function () {
                            $scope.doFilterCollection($scope.internshipsData);

                            $scope.internshipsData.start = 0;
                            $scope.internshipsData.page = 0;
                        };

                        // filter functions
                        $scope.doFilterCollection = function (collection) {
                            collection.filtered = collection.full.filter(function (internship) {
                                var isvalid = true;
                                if ($scope.filters.input.basename !== $scope.basenameDefault) {
                                    if ($scope.filters.input.basename !== internship.base) {
                                        isvalid = false;
                                    }
                                }
                                if ($scope.filters.input.audience !== $scope.audienceDefault) {
                                    if ($scope.filters.input.audience !== internship.public) {
                                        isvalid = false;
                                    }
                                }

                                if ($scope.filters.input.date !== '') {
                                    var filteredDate = moment($scope.filters.input.date, ["DD/MM/YYYY"]);

                                    if (filteredDate.isValid()
                                        && filteredDate.isAfter(internship.startDate)) {
                                        isvalid = false;
                                    }

                                }
                                return isvalid;
                            })


                        };
                        $scope.retrievePages = function (entry) {
                            var nbpages = Math.ceil(entry.filtered.length / $scope.defaultNumberToShow);
                            return new Array(nbpages);
                        };
                        $scope.clearFilter = function () {
                            $scope.filters.input.basename = $scope.basenameDefault;
                            $scope.filters.input.audience = $scope.audienceDefault;
                            $scope.filters.input.date = '';
                            $scope.doFilter();
                        };

                        // event handler for pagination
                        $scope.changePage = function (internships, page) {
                            internships.page = page;
                            internships.start = page * $scope.defaultNumberToShow;
                            // TODO: add scroll
                        };
                        $scope.isLastPage = function (entry) {
                            return (entry.page + 1) >= Math.ceil(entry.filtered.length / $scope.defaultNumberToShow);
                        };

                        //$scope.internshipsData =
                        $scope.isOlderInternship = $drupal.getCourses().then(function (internships) {
                            $scope.inter = internships.reduce(function (a, b) {
                                return a.startDate < b.startDate ? a.startDate : b.startDate;
                            })
                        })

                        // retrieve list of evaluations
                        $drupal.getCourses().then(function (internships) {

                            $scope.today = new moment().format("YYYY-MM-DD");
                            $scope.internshipsData.full = internships.map(function (internship) {
                                internship.hasFeedback = Object.keys(internship.marks).some(function (k) {
                                    return internship.marks[k] !== null;
                                });

                                internship.globalMark = tools.parseMark(internship.globalMark);
                                return internship;
                            })
                            .sort(function(a,b) {
                                return a.startDate > b.startDate ? -1 : a.startDate < b.startDate ? -1 : 0
                            })
                            .filter(function(internship) {
                                var filtered = ['Gestion'];
                                return internship.endDate < $scope.today
                                    && (!internship.activity || filtered.indexOf(internship.activity) === -1);
                            });
                            $scope.doFilter();
                        })

                        .finally(function () {
                            $scope.pending = false;
                        });

                        // event handler for internships button
                        $scope.actionList = function (action, internship) {
                            if (action === 'detail') {
                                // TODO: control if internship id is right
                                $state.go('member.assessments.detail.notation', {id: internship.internshipId, slug: $filter('slugify')(internship.name) });
                            }
                        };
                        utils.calendarTrad()
                    }],
                    templateUrl: 'src/views/member/assessments/member_assessments_list.html'
                }
            }
        })
        .state('member.assessments.detail', {
            url: '{slug}--{id}/',
            abstract: true,
            views: {
                subcontent: {
                    controller: ['$q', '$scope', '$stateParams', 'drupal', function ($q, $scope, $stateParams, $drupal) {
                        // retrieve internship detail information (once for all within each screen concerning this internship)
                        var internshipId = $stateParams.id;
                        $scope.internship = {};

                        $scope.loading = true;

                        $drupal.getInternship(internshipId).then(function (internship) {
                            $scope.internship = angular.copy(internship[0]);
                            $scope.internship.base.name = $scope.internship.base.name || $scope.internship.base.base.name;
                            $scope.internship.base.region = $scope.internship.base.region || $scope.internship.base.base.region;
                            $scope.loading = false;
                        });
                    }],
                    templateUrl: 'src/views/member/assessments/member_assessments_detail.html'
                }
            }
        });
    }]);
